(function () {
  'use strict';

  var SITE_KEY = '6LcNP54tAAAAAEnAq-LHW_bqliy82SI-6uNYQGqG';
  var pendingLink = null;
  var widgetId = null;
  var modal = null;

  function isIntakeLink(anchor) {
    if (!anchor || !anchor.href) return false;

    try {
      var url = new URL(anchor.href, window.location.href);
      var hostname = url.hostname.toLowerCase();
      var isProtectedDomain =
        hostname === 'intake.com' ||
        hostname.endsWith('.intake.com') ||
        hostname === 'intakeq.com' ||
        hostname.endsWith('.intakeq.com');

      return (url.protocol === 'https:' || url.protocol === 'http:') && isProtectedDomain;
    } catch (error) {
      return false;
    }
  }

  function loadRecaptcha() {
    if (document.querySelector('script[data-intake-recaptcha]')) return;
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?onload=initializeIntakeRecaptcha&render=explicit';
    script.async = true;
    script.defer = true;
    script.dataset.intakeRecaptcha = 'true';
    document.head.appendChild(script);
  }

  function completeRedirect() {
    if (!pendingLink) return;
    var destination = pendingLink.href;
    var openInNewTab = pendingLink.target === '_blank';
    closeModal();
    if (openInNewTab) {
      window.open(destination, '_blank', 'noopener,noreferrer');
    } else {
      window.location.assign(destination);
    }
  }

  function showError() {
    var message = modal && modal.querySelector('[data-intake-recaptcha-error]');
    if (message) message.hidden = false;
  }

  function resetChallenge() {
    if (window.grecaptcha && widgetId !== null) window.grecaptcha.reset(widgetId);
    var message = modal && modal.querySelector('[data-intake-recaptcha-error]');
    if (message) message.hidden = true;
  }

  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('intake-recaptcha-open');
    resetChallenge();
    var closeButton = modal.querySelector('[data-intake-recaptcha-close]');
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('intake-recaptcha-open');
    pendingLink = null;
    resetChallenge();
  }

  window.initializeIntakeRecaptcha = function () {
    var container = document.getElementById('intake-recaptcha-widget');
    if (!container || !window.grecaptcha || widgetId !== null) return;
    widgetId = window.grecaptcha.render(container, {
      sitekey: SITE_KEY,
      callback: completeRedirect,
      'expired-callback': resetChallenge,
      'error-callback': showError
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    modal = document.getElementById('intake-recaptcha-modal');
    if (!modal) return;
    loadRecaptcha();

    document.addEventListener('click', function (event) {
      var anchor = event.target.closest('a[href]');
      if (!isIntakeLink(anchor)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      pendingLink = { href: anchor.href, target: anchor.getAttribute('target') };
      openModal();
    }, true);

    modal.addEventListener('click', function (event) {
      if (event.target.matches('[data-intake-recaptcha-close], [data-intake-recaptcha-backdrop]')) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
}());
